import { render } from "./AllocationResult.vue?vue&type=template&id=66cdd3fb"
import script from "./AllocationResult.vue?vue&type=script&lang=js"
export * from "./AllocationResult.vue?vue&type=script&lang=js"
script.render = render

export default script